/** @deprecated
 *  Non-reactive store only for support analytics @see YandexMetricaApiService */
export default class Meta {
  meta: Entity.Meta = {
    title: "Здравсити",
    description: "",
    h1: "",
    breadcrumbs: [] as Array<Entity.Breadcrumb>,
    microdata: "",
    metadata: [],
  };

  toJSON() {
    return {};
  }

  set(meta: Entity.Meta): void {
    this.meta = {
      title: meta.title,
      description: meta.description,
      h1: meta.h1,
      breadcrumbs: meta.breadcrumbs,
      microdata: meta.microdata,
      metadata: meta.metadata,
    };
  }
}
